export default __webpack_public_path__ + "static/media/error.1dbffa24.svg";